/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { ITechnicalExpertiseData } from "Interfaces/SiteContent/ITechnicalExpertiseData";

import {
  TECHNICAL_EXPERTISE_LOAD,
  TECHNICAL_EXPERTISE_LOAD_FAILURE,
  TECHNICAL_EXPERTISE_LOAD_SUCCESS,
} from "./TechnicalExpertiseTypes";

/**
 * Action for getting the industry focuses
 */
export interface IGetTechnicalExpertise {
  type: typeof TECHNICAL_EXPERTISE_LOAD;
}

/**
 * Action getting the industry focuses when successful
 */
export interface IGetTechnicalExpertiseSuccess {
  type: typeof TECHNICAL_EXPERTISE_LOAD_SUCCESS;
  technicalExpertise: ITechnicalExpertiseData[];
}

/**
 * Action getting the industry focuses when failure
 */
export interface IGetTechnicalExpertiseFailure {
  type: typeof TECHNICAL_EXPERTISE_LOAD_FAILURE;
  technicalExpertiseLoadError: string;
}

/**
 * Action creator for getting the industry focuses
 */
export const getTechnicalExpertise = (): TechnicalExpertiseActionTypes => ({
  type: TECHNICAL_EXPERTISE_LOAD,
});

/**
 * Action creator for getting industry focuses when success
 * @param technicalExpertise
 */
export const getTechnicalExpertiseSuccess = (
  technicalExpertise: ITechnicalExpertiseData[]
): TechnicalExpertiseActionTypes => ({
  type: TECHNICAL_EXPERTISE_LOAD_SUCCESS,
  technicalExpertise,
});

/**
 * Action creator for getting industry focuses when failure
 * @param TechnicalExpertiseLoadError
 */
export const getTechnicalExpertiseFailure = (
  technicalExpertiseLoadError: string
): TechnicalExpertiseActionTypes => ({
  type: TECHNICAL_EXPERTISE_LOAD_FAILURE,
  technicalExpertiseLoadError,
});

export type TechnicalExpertiseActionTypes =
  | IGetTechnicalExpertise
  | IGetTechnicalExpertiseSuccess
  | IGetTechnicalExpertiseFailure;
